export const LOOT_RARITY = Object.freeze({
  common: {
    label: 'Common',
    glowColor: null,
    lightIntensity: 0,
    pulseSpeed: 0,
    lightFlicker: 0,
    particleRing: false,
  },
  uncommon: {
    label: 'Uncommon',
    glowColor: 0x8888ff,
    lightIntensity: 0.4,
    pulseSpeed: 0,
    lightFlicker: 0,
    particleRing: false,
  },
  rare: {
    label: 'Rare',
    glowColor: 0x8844ff,
    lightIntensity: 0.8,
    pulseSpeed: 1.2,
    lightFlicker: 0.08,
    particleRing: false,
  },
  legendary: {
    label: 'Legendary',
    glowColor: 0xff6600,
    lightIntensity: 1.5,
    pulseSpeed: 3.2,
    lightFlicker: 0.18,
    particleRing: true,
  },
});

export const ENEMY_DROP_TABLE = Object.freeze({
  drone: { chance: 0.15, rarityWeights: { common: 1 } },
  enforcer: { chance: 0.35, rarityWeights: { common: 0.7, uncommon: 0.3 } },
  zealot: { chance: 0.4, rarityWeights: { common: 0.8, uncommon: 0.2 } },
  minmon: { chance: 0.25, rarityWeights: { common: 0.8, uncommon: 0.2 } },
  zilua: { chance: 0.5, rarityWeights: { rare: 0.65, legendary: 0.35 } },
  boss: { chance: 1, rarityWeights: { legendary: 1 } },
});

export const ROOM_CLEAR_REWARD_TABLE = Object.freeze([
  {
    min: 1,
    max: 3,
    rewardWeights: { weapon: 0.5, ammo: 0.3, hp: 0.2 },
    weaponRarityWeights: { common: 0.8, uncommon: 0.2 },
  },
  {
    min: 4,
    max: 6,
    rewardWeights: { weapon: 0.6, ammo: 0.25, hp: 0.15 },
    weaponRarityWeights: { common: 0.4, uncommon: 0.45, rare: 0.15 },
  },
  {
    min: 7,
    max: 10,
    rewardWeights: { weapon: 0.7, ammo: 0.2, hp: 0.1 },
    weaponRarityWeights: { uncommon: 0.3, rare: 0.5, legendary: 0.2 },
  },
]);
